import React, { FunctionComponent } from "react";
import BrightcoverPlayer from "@brightcove/react-player-loader";
import { VideoPlayerProps } from "../interfaces"
import { PlayerWrapper } from "../styled"
import { withPrefix } from "gatsby"

const VideoPlayer: FunctionComponent<VideoPlayerProps> = ({
  onError,
  onSuccess,
  videoId,
  accoundId,
  playerId,
  placeholder,
  enablePlaceholder,
}) => {

  return (
    <PlayerWrapper enablePlaceholder={enablePlaceholder} placeholder={withPrefix(placeholder)} >
      <BrightcoverPlayer
        attrs={{ 
          className: "player",
          id: 'PlayerId',
          'data-autoplay': true,
          muted: false,
          autoPlay: true
        }}
        playerId={playerId}
        accountId={accoundId}
        onSuccess={onSuccess}
        onFailure={onError}
        videoId={videoId}
        // adding/removing attributes or adding child elements, such as sources or tracks.
        // onEmbedCreated
      />
    </PlayerWrapper>
  );
};

export interface getTextTrackByKindType {
  tracks: TextTrack[],
  kind: string
}
export const getTextTrackByKind = ({tracks, kind}:getTextTrackByKindType) => {
  const tracksCount = tracks.length
  const results = []
  for (var index = 0; index < tracksCount; index++) {
    if(tracks[index].kind === kind){
      results.push(tracks[index])
    }
  }
  return results
}
export default VideoPlayer;
